import React from 'react'
import { connect } from 'react-redux'
import { hideModal } from '../actions/modal'

import './Modal.css';

import ReactModal from 'react-modal'

const NewModal = ({
  dispatch,
  modalType,
  modalProps,
  hideModal
}) => {
  const ModalContent = modalType || Empty;
  const isOpen = modalType ? true : false;
  return (
    <ReactModal
      // overlayClassName="modal show"
      className="modal__table"
      // className={{
      //   base: 'modal__table',
      //   afterOpen: 'myClass_after-open',
      //   beforeClose: 'myClass_before-close'
      // }}
      overlayClassName={{
        base: 'modal',
        afterOpen: 'show',
        beforeClose: ''
      }}
      isOpen={isOpen}
      // onAfterOpen={afterOpenFn}
      onRequestClose={hideModal}
      // closeTimeoutMS={n}
      // style={customStyle}
      contentLabel="Modal"
    >
      {/* <ModalContent {...modalProps} hideModal={hideModal}/> */}
      <div className="modal__cell">
        <div className="modal__content">
          <ModalContent {...modalProps} hideModal={hideModal}/>
          <div className="modal__close" onClick={hideModal}>×</div>
        </div>
      </div>
    </ReactModal>
  )
}

const Empty = () => (
  <div>Empty</div>
)

const Modal = ({
  children,
  showModal,
  toggleModal,
  dispatch,
  modalType,
  modalProps,
  hideModal
}) => {
  if (true) {
    const classname = modalType ? 'modal show' : 'modal';
    const ModalContent = modalType || Empty;
    return (
      <div className={classname}>
        {/* <div className="modal__overlay" onClick={toggleModal}></div> */}
        <div className="modal__table">
          <div className="modal__cell">
            <div className="modal__content">
              {/* {children} */}
              <ModalContent {...modalProps} hideModal={hideModal}/>
              <div className="modal__close" onClick={hideModal}>×</div>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return null;
  }
}

export default connect(
  state => state.modal,
  { hideModal }
)(NewModal)


// WEBPACK FOOTER //
// ./src/components/Modal.js